import { gql } from '@apollo/client';

export const floorPlanObjectFragment = gql`
  fragment FloorPlanObjectFields on FloorPlanObjectLibraryItem {
    id
    name
    typeName
    width
    height
    chairs
    fill
    stroke
    category
    default
    venueId
    editable
  }
`;

export const eventFloorPlanFragment = gql`
  fragment EventFloorPlanFields on EventFloorPlan {
    id
    name
    eventId
    spaceId
    floorPlanTemplateId
    canvasWidth
    canvasHeight
    gridSize
    basis
    objects
    backgroundImageUrl
    snapshotUrl
    createdAt
    updatedAt
    space {
      id
      name
    }
  }
`;

export const floorPlanTemplateFragment = gql`
  fragment FloorPlanTemplateFields on FloorPlanTemplate {
    id
    name
    spaceId
    canvasWidth
    canvasHeight
    gridSize
    basis
    objects
    backgroundImageUrl
    usageCount
    createdAt
    updatedAt
    space {
      id
      name
    }
  }
`;

export const eventFloorPlanQuery = gql`
  ${eventFloorPlanFragment}
  query EventFloorPlan($eventId: ID!) {
    eventFloorPlan(eventId: $eventId) {
      ...EventFloorPlanFields
    }
  }
`;

export const eventFloorPlansQuery = gql`
  ${eventFloorPlanFragment}
  query EventFloorPlans($eventId: ID!, $spaceId: ID) {
    eventFloorPlans(eventId: $eventId, spaceId: $spaceId) {
      ...EventFloorPlanFields
    }
  }
`;

export const floorPlanObjectLibraryQuery = gql`
  ${floorPlanObjectFragment}
  query FloorPlanObjectLibrary($venueId: ID!) {
    floorPlanObjectLibrary(venueId: $venueId) {
      ...FloorPlanObjectFields
    }
  }
`;

export const floorPlanTemplatesQuery = gql`
  ${floorPlanTemplateFragment}
  query FloorPlanTemplates($venueId: ID!, $spaceId: ID) {
    floorPlanTemplates(venueId: $venueId, spaceId: $spaceId) {
      ...FloorPlanTemplateFields
    }
  }
`;

export const floorPlanTemplateQuery = gql`
  ${floorPlanTemplateFragment}
  query FloorPlanTemplate($id: ID!) {
    floorPlanTemplate(id: $id) {
      ...FloorPlanTemplateFields
    }
  }
`;

export const createEventFloorPlanMutation = gql`
  ${eventFloorPlanFragment}
  mutation CreateEventFloorPlan($input: CreateEventFloorPlanInput!) {
    createEventFloorPlan(input: $input) {
      eventFloorPlan {
        ...EventFloorPlanFields
      }
      errors
    }
  }
`;

export const updateEventFloorPlanMutation = gql`
  ${eventFloorPlanFragment}
  mutation UpdateEventFloorPlan($input: UpdateEventFloorPlanInput!) {
    updateEventFloorPlan(input: $input) {
      eventFloorPlan {
        ...EventFloorPlanFields
      }
      errors
    }
  }
`;

export const deleteEventFloorPlanMutation = gql`
  mutation DeleteEventFloorPlan($input: DeleteEventFloorPlanInput!) {
    deleteEventFloorPlan(input: $input) {
      success
      errors
    }
  }
`;

export const createFloorPlanTemplateMutation = gql`
  ${floorPlanTemplateFragment}
  mutation CreateFloorPlanTemplate($input: CreateFloorPlanTemplateInput!) {
    createFloorPlanTemplate(input: $input) {
      floorPlanTemplate {
        ...FloorPlanTemplateFields
      }
      errors
    }
  }
`;

export const updateFloorPlanTemplateMutation = gql`
  ${floorPlanTemplateFragment}
  mutation UpdateFloorPlanTemplate($input: UpdateFloorPlanTemplateInput!) {
    updateFloorPlanTemplate(input: $input) {
      floorPlanTemplate {
        ...FloorPlanTemplateFields
      }
      errors
    }
  }
`;

export const duplicateFloorPlanTemplateMutation = gql`
  ${floorPlanTemplateFragment}
  mutation DuplicateFloorPlanTemplate($input: DuplicateFloorPlanTemplateInput!) {
    duplicateFloorPlanTemplate(input: $input) {
      floorPlanTemplate {
        ...FloorPlanTemplateFields
      }
      errors
    }
  }
`;

export const deleteFloorPlanTemplateMutation = gql`
  mutation DeleteFloorPlanTemplate($input: DeleteFloorPlanTemplateInput!) {
    deleteFloorPlanTemplate(input: $input) {
      success
      errors
    }
  }
`;

export const generateEventFloorPlansPdfMutation = gql`
  mutation GenerateEventFloorPlansPdf($input: GenerateEventFloorPlansPdfInput!) {
    generateEventFloorPlansPdf(input: $input) {
      pdfUrl
      filename
      errors
    }
  }
`;

export const createFloorPlanObjectLibraryItemMutation = gql`
  ${floorPlanObjectFragment}
  mutation CreateFloorPlanObjectLibraryItem($input: CreateFloorPlanObjectLibraryItemInput!) {
    createFloorPlanObjectLibraryItem(input: $input) {
      objectLibraryItem {
        ...FloorPlanObjectFields
      }
      errors
    }
  }
`;

export const updateFloorPlanObjectLibraryItemMutation = gql`
  ${floorPlanObjectFragment}
  mutation UpdateFloorPlanObjectLibraryItem($input: UpdateFloorPlanObjectLibraryItemInput!) {
    updateFloorPlanObjectLibraryItem(input: $input) {
      objectLibraryItem {
        ...FloorPlanObjectFields
      }
      errors
    }
  }
`;

export const deleteFloorPlanObjectLibraryItemMutation = gql`
  mutation DeleteFloorPlanObjectLibraryItem($input: DeleteFloorPlanObjectLibraryItemInput!) {
    deleteFloorPlanObjectLibraryItem(input: $input) {
      errors
    }
  }
`;
